import { IconLink } from "@tabler/icons-react";
import { Link } from "react-router-dom";

const actionBase =
  "inline-flex shrink-0 items-center justify-center gap-1.5 rounded-lg px-4 py-2 text-sm font-medium shadow-sm transition-colors";

export function IntegrationConnectButton({
  children = "Connect",
  onClick,
  disabled,
}: {
  children?: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={`${actionBase} cursor-pointer bg-[#155dfc] text-white hover:bg-blue-600 disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500 disabled:shadow-none`}
    >
      <IconLink size={16} stroke={2} className="opacity-90" />
      {children}
    </button>
  );
}

export function IntegrationOutlineButton({
  children,
  onClick,
  to,
}: {
  children: React.ReactNode;
  onClick?: () => void;
  to?: string;
}) {
  const className = `${actionBase} cursor-pointer border border-[#155dfc] bg-white text-[#155dfc] hover:bg-[#eff6ff]`;

  if (to) {
    return (
      <Link to={to} className={className}>
        {children}
      </Link>
    );
  }

  return (
    <button type="button" onClick={onClick} className={className}>
      {children}
    </button>
  );
}

export function IntegrationConnectedButton() {
  return (
    <button
      type="button"
      disabled
      className={`${actionBase} cursor-default bg-emerald-600 text-white disabled:opacity-100`}
    >
      Connected
    </button>
  );
}

export function IntegrationDisabledButton({ children = "Connect" }: { children?: React.ReactNode }) {
  return (
    <button
      type="button"
      disabled
      className={`${actionBase} cursor-not-allowed border border-slate-200 bg-slate-100 text-slate-400 shadow-none`}
    >
      {children}
    </button>
  );
}
